import React, { memo } from 'react';
import logoGovCo from '../img/gov-co.png';

/**
 * Barra superior GOV.CO (top bar institucional).
 *
 * Requisito de la Resolución MinTIC 1519 de 2020, Anexo 2, numeral 2.1:
 * todo sitio web fuera del dominio principal institucional debe incluir una
 * barra superior con el logotipo GOV.CO que redirija al Portal Único del
 * Estado Colombiano (https://www.gov.co/home/), presente en todas las páginas y vistas.
 *
 * Especificaciones del Kit UI GOV.CO v9.2 (Barra superior):
 *  - Único color de fondo: azul Cobalt #0943B5 (token `cobalt`).
 *  - Altura de 56 px (h-14).
 *  - Logo con relación 24 × 136 px (alto 24 px).
 *  - Área activa mínima de 44 × 44 px para pantallas táctiles.
 *  - El logo redirige a https://www.gov.co/home/.
 */
const GovBar = () => {
  return (
    <div className="w-full bg-cobalt">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 h-14 flex items-center">
        <a
          href="https://www.gov.co/home/"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Ir al Portal Único del Estado Colombiano GOV.CO (abre en una nueva pestaña)"
          className="inline-flex items-center min-h-[44px] min-w-[44px] focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-cobalt rounded"
        >
          <img
            src={logoGovCo}
            alt="Logo Gobierno de Colombia GOV.CO"
            className="h-6 w-auto object-contain"
          />
        </a>
      </div>
    </div>
  );
};

export default memo(GovBar);
